import React from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { updateFormState } from '../actions';

class FormBody extends React.Component{

    constructor(props){
        super(props);
        this.handleResetClick = this.handleResetClick.bind(this);
        this.handleSubmitClick = this.handleSubmitClick.bind(this);
    }

    handleResetClick(){
        const { form } = this.props;
        form.reset();
        form.initialize({});
    }

    handleSubmitClick(){
        document.getElementById('payments-filters').dispatchEvent(
            new Event('submit',{
                cancelable: true
            })
        )
    }

    render(){
        const { handleSubmit } = this.props;
        return (
            <div className="card-body col-12">
                <form id='payments-filters' onSubmit={handleSubmit}>
                  <div className="row input-daterange datepicker flex-sm-column flex-md-row">
                      <div className="col-lg-3 col-sm-12">
                            <div className="form-group">
                                <label className="form-control-label">Período</label>
                                <div className="input-group input-group-alternative">
                                    <Field
                                        className="form-control"
                                        name="startDate"
                                        component="input"
                                        type="date"
                                    />
                                    <Field
                                        className="form-control"
                                        name="endDate"
                                        component="input"
                                        type="date"
                                    />
                                </div>
                            </div>
                            <div>
                                  <div className="form-group">
                                      <label className="form-control-label">Data de Captura</label>
                                      <div className="input-group input-group-alternative">
                                          <Field
                                              className="form-control"
                                              name="startCaptureDate"
                                              component="input"
                                              type="date"
                                          />
                                          <Field
                                              className="form-control"
                                              name="endCaptureDate"
                                              component="input"
                                              type="date"
                                          />
                                      </div>
                                  </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-12">
                            <div className="form-group">
                                <label className="form-control-label">Protocolo</label>
                                <Field
                                    className="form-control form-control-alternative"
                                    name="protocol"
                                    component="input"
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <button type="submit" className="btn btn-success my-4">Aplicar</button>
                        <button type="button" onClick={this.handleResetClick} className="btn btn-danger my-4">Limpar</button>
                    </div>
                </form>
            </div>
        )
    }
}

function PaymentsFilterForm({ initialValues, updateFormState }){
    return (
        <Form
            onSubmit={(values) =>{
                updateFormState(values)
            }}
            initialValues={initialValues}
            render={(props) => ( <FormBody {...props} />)}
        />
    );
}

const mapsStateToProps = (state) => ({
    initalValues: state.payments.filters
});

const mapDispatchToProps = {
    updateFormState
};

export default connect(mapsStateToProps, mapDispatchToProps)(PaymentsFilterForm);



// WEBPACK FOOTER //
// ./src/components/Pages/Payments/Filters/index.js